/**
 * Reducer to manage data coming from other flows to interact with cross border
 */

import { ActionTypes as types } from '../constants'

let initialState = {
  from: null,
  toCountry: null,
}

/**
 * Reducer. Pure function that mutates this part of the store
 * and returns a new obj.
 */
export default function flowModel(state = initialState, action) {
  switch (action.type) {
    case types.SET_INITIAL_FLOW_MODEL:
      // Add data to initial state for when RESET_TO_INITIAL action is dispatched
      initialState = {
        ...state,
        ...action.data,
      }
      return initialState
    default:
      return state
  }
}
